import { useQuery } from '@tanstack/react-query';
import buildHeaderImageUrl from '../utils/buildHeaderImageUrl';

export const profileHeaderUserQueryKey = 'profileHeaderUserQueryKey';

export type ProfileHeaderApiResponse = {
  data: {
    User: {
      id: string;
      headerImageUrl: string;
    };
  };
  extensions: {
    errorNumber: number;
  };
};

type ProfileHeaderUserQueryData = {
  id: string;
  headerImageUrl: string | null;
};

const profileHeaderUserQuery = async (
  userId: string,
): Promise<ProfileHeaderUserQueryData> => {
  const headerImageUrl = await buildHeaderImageUrl(userId);
  return {
    id: userId,
    headerImageUrl,
  };
};
export const useProfileHeaderUserQuery = (userId: string) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: [profileHeaderUserQueryKey, userId],
    queryFn: () => profileHeaderUserQuery(userId),
  });

  return { data, isLoading, isError };
};
